import { useState, useEffect } from "react"
import { toast } from "react-toastify"
import Input from "../Input"
import { getBannerSettings, updateBannerSettings } from "../../services/bannerSettingApis"

const BannerDynamic = ({ user }) => {
    const [settings, setSettings] = useState(null)

    useEffect(() => {
        if (user) {
            getBannerSettings()
                .then(({ data }) => {
                    setSettings(data)
                })
                .catch((err) => {
                    console.error(err)
                })
        }
    }, [user])
    if (!settings) {
        return (
            <>
                <h3>درحال بارگذاری...</h3>
            </>
        )
    }
    return (
        <div dir="ltr" className="w-full h-full y-scroll">
            <div dir="rtl" className="mx-14">
                <h3 className="mb-5">لیست قیمت بنر داینامیک:</h3>
                <form
                    onSubmit={(event) => {
                        event.preventDefault()
                        const form = new FormData(event.target)
                        let newData = {
                            settings: {},
                        }

                        for (let i in settings) {
                            const settingName = settings[i].name
                            newData.settings[settingName] = form.get(settingName)
                        }

                        toast
                            .promise(updateBannerSettings(newData), {
                                pending: "درحال اپدیت قیمت ها",
                                success: "اپدیت شد",
                            })
                            .catch((err) => {
                                console.error(err)
                            })
                    }}
                >
                    {settings &&
                        settings.map((item, index) => {
                            return (
                                <div className="mb-3" key={index}>
                                    <label for={item.name} class="block mb-2 text-sm font-medium  text-gray-300">
                                        {item.desc}
                                    </label>

                                    <Input
                                        type="number"
                                        name={item.name}
                                        placeholder={item.name}
                                        defaultValue={item.price}
                                    />
                                </div>
                            )
                        })}

                    <button type="submit" className="styled-button border px-4 py-2 m-2">
                        آپدیت
                    </button>
                </form>
            </div>
        </div>
    )
}

export default BannerDynamic
